'use client';

import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@/icons';
import { cn } from '@/utils';
const Accordion = AccordionPrimitive.Root;
const AccordionItem = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Item>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>>(({
  className,
  ...props
}, ref) => <AccordionPrimitive.Item ref={ref} className={cn(className)} {...props} />);
AccordionItem.displayName = 'AccordionItem';
const AccordionTriggerBase = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
  asChild?: boolean;
}>(({
  className,
  children,
  asChild,
  ...props
}, ref) => <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger ref={ref} asChild={asChild} className={cn('flex flex-1 items-center cursor-pointer min-h-[44px] gap-xs py-xs px-md text-body-lg-bold transition-all text-left', className)} {...props}>
      {children}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>);
AccordionTriggerBase.displayName = 'AccordionTriggerBase';
const AccordionTrigger = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & {
  icon?: React.ReactNode | null;
}>(({
  className,
  children,
  icon,
  ...props
}, ref) => <AccordionTriggerBase ref={ref} className={cn('justify-between [&[data-state=open]>svg]:rotate-180', className)} {...props}>
    {children}
    {icon !== undefined ? icon : <ChevronDownIcon size={'sm'} className={'shrink-0'} />}
  </AccordionTriggerBase>);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
const AccordionTriggerNoIcon = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Trigger>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>>(({
  className,
  children,
  ...props
}, ref) => <AccordionTriggerBase ref={ref} className={className} {...props}>
    {children}
  </AccordionTriggerBase>);
AccordionTriggerNoIcon.displayName = 'AccordionTriggerNoIcon';
const AccordionContent = React.forwardRef<React.ElementRef<typeof AccordionPrimitive.Content>, React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>>(({
  className,
  children,
  ...props
}, ref) => <AccordionPrimitive.Content ref={ref} className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down" {...props}>
    <div className={cn('py-md pl-lg', className)}>{children}</div>
  </AccordionPrimitive.Content>);
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
export { Accordion, AccordionItem, AccordionTrigger, AccordionTriggerNoIcon, AccordionContent };